import { Account } from '@modules-deprecated/app/accounts/types'

export const getExcludedAccountIds = (accounts: Account[]): string[] =>
  accounts.filter((account) => !account.predefinedAccount).map(({ id }) => id)

export const getAccountById = (accounts: Account[], accountId: string): Account | undefined =>
  accounts.find(({ id }) => id === accountId)

export const getAccountNumberFromAccount = (account?: Account): number | null => account?.accountNo ?? null

export const getSelectedBaseAccountId = (accounts: Account[], account?: Account): string | undefined => {
  if (!account) {
    return undefined
  }

  return accounts.find(
    (candidate) => candidate.predefinedAccount && candidate.publicAccountId === account.publicAccountId,
  )?.id
}
